import { mapSymbols } from '../../../helpers';

import baseSymbols from './symbols.json';

export default mapSymbols(baseSymbols, 'Music');
